import { withInstall } from '@hd-front-end/utils'
import CheckTag from './src/check-tag.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElCheckTag: SFCWithInstall<typeof CheckTag> = withInstall(CheckTag)
export default ElCheckTag

export * from './src/check-tag'
